module.exports = __webpack_public_path__ + "static/img/shop-flow.d268271.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/amuletj/shop-flow.png
// module id = s8Jz
// module chunks = 2